import { env } from 'next-runtime-env'

export const SEARCH_PARAM_KEYS = {
  HTC_TOKEN: 'htc_account_access_token',
  RETICULUM_TOKEN: 'reticulum_token',
  EMAIL: 'email',
  RETRY_AFTER: 'retry_after',
  AVATAR: 'avatar_url',
  SNAPSHOT: 'snapshot_url',
  HEAD_ICON: 'head_icon_url',
  DISPLAY_NAME: 'display_name',
  IS_HALF_BODY: 'is_half_body',
  GENDER: 'gender',
  IS_NEW_USER: 'is_new_user',
  OPEN_CREATE_DIALOG: 'create',
  CREATE_DIALOG_TEMPLATE_TYPE: 'template',
  SOURCE: 'source',
  APP_ID: 'app_id',
  APP_STATE: 'app_state',
  STATE: 'state',
  PREVIEW: 'preview',
} as const

const runtimeEnvironment = env('NEXT_PUBLIC_ENVIRONMENT') ?? ''
const environmentSuffix =
  { production: 'production', development: 'dev' }[runtimeEnvironment] ?? 'stage'

export const HTC_ACCESS_TOKEN_KEY = `_htc_access_token_${environmentSuffix}`
